<template>
	<div
		class="modal fade"
		:id="id"
		tabindex="-1"
		role="dialog"
		aria-labelledby="exampleModalLabel"
		aria-hidden="true"
		data-backdrop="static"
		data-keyboard="false"
	>
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title text-white" id="exampleModalLabel">Live Chat</h5>
					<button
						type="button"
						@click="close()"
						class="close"
						data-dismiss="modal"
						aria-label="Close"
					>
						<span class="text-white" aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<div class="content container-fluid bootstrap snippets bootdey">
						<div class="row row-broken">
							<div
								class="col-sm-12 col-xs-12 chat"
								id="chat_div"
								style="overflow: scroll; max-height: 35rem"
							>
								<div class="col-inside-lg decor-default">
									<div class="chat-body">
										<h3 v-if="loading" class="text-center">Loading Messages...</h3>
										<div v-for="(message, index) in messages" :key="index">
											<div class="answer left" v-if="message.user_type == 'admin'">
												<div class="avatar">
													<img
														src="https://avatars.dicebear.com/api/avataaars/admin.svg"
														alt="User name"
													/>
													<div class="status online"></div>
												</div>
												<div class="name">iSwitch</div>
												<div class="text">{{ message.message }}</div>
												<div class="time">{{ formatDate(message.date) }}</div>
											</div>
											<div class="answer right" v-if="message.user_type == 'customer'">
												<div class="avatar">
													<img
														src="https://avatars.dicebear.com/api/avataaars/customer.svg"
														alt="User name"
													/>
													<div class="status online"></div>
												</div>
												<div class="name">User</div>
												<div class="text">{{ message.message }}</div>
												<div class="time">{{ formatDate(message.date) }}</div>
											</div>
										</div>
										<div class="answer left" v-if="isTyping">
											<div class="avatar">
												<img
													src="https://avatars.dicebear.com/api/avataaars/admin.svg"
													alt="User name"
												/>
												<div class="status online"></div>
											</div>
											<div class="name">iSwitch</div>
											<div class="text mb-4"><Typing /></div>
										</div>
										<div class="answer-add">
											<textarea
												placeholder="Write a message"
												rows="2"
												v-model="message"
												@keydown="handleMessageType()"
											></textarea>
											<i class="fa fa-paper-plane text-white" @click="sendMessage"></i>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from "axios";
	import Typing from "../Loaders/Typing.vue";
	import moment from "moment";

	export default {
		props: ["show", "id", "messages", "isTyping", "loading"],
		data() {
			return {
				message: "",
			};
		},
		components: {
			Typing,
		},
		methods: {
			close() {
				this.$emit("close");
			},
			handleMessageType() {
				this.$emit("typing", true);
			},
			sendMessage() {
				if (!this.message) return;
				this.$emit("sendMessage", this.message);
				this.message = "";
			},
			formatDate(date) {
				return moment(date).fromNow();
			},
		},
		mounted() {
			if (this.show) {
				$("#" + this.id).modal("show");
			} else {
				$("#" + this.id).modal("hide");
			}
		},
		watch: {
			show(val) {
				if (val) {
					$("#" + this.id).modal("show");
				} else {
					$("#" + this.id).modal("hide");
				}
			},
		},
	};
</script>

<style scoped>
	.modal-header {
		background-color: #7266ba;
	}
	.modal-content {
		border: 0px;
		border-radius: 30px;
	}
	.modal-header {
		display: flex;
		align-items: center;
	}
	.modal-body {
		height: max-content;
	}

	.row.row-broken {
		padding-bottom: 0;
	}
	.col-inside-lg {
		padding: 20px;
	}
	.chat {
		height: max-content;
	}
	.decor-default {
		background-color: #ffffff;
	}
	.chat-users h6 {
		font-size: 20px;
		margin: 0 0 20px;
	}
	.chat-users .user {
		position: relative;
		padding: 0 0 0 50px;
		display: block;
		cursor: pointer;
		margin: 0 0 20px;
	}
	.chat-users .user .avatar {
		top: 0;
		left: 0;
	}
	.chat .avatar {
		width: 40px;
		height: 40px;
		position: absolute;
	}
	.chat .avatar img {
		display: block;
		border-radius: 20px;
		height: 100%;
	}
	.chat .avatar .status.off {
		border: 1px solid #5a5a5a;
		background: #ffffff;
	}
	.chat .avatar .status.online {
		background: #4caf50;
	}
	.chat .avatar .status.busy {
		background: #ffc107;
	}
	.chat .avatar .status.offline {
		background: #ed4e6e;
	}
	.chat-users .user .status {
		bottom: 0;
		left: 28px;
	}
	.chat .avatar .status {
		width: 10px;
		height: 10px;
		border-radius: 5px;
		position: absolute;
	}
	.chat-users .user .name {
		font-size: 14px;
		font-weight: bold;
		line-height: 20px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.chat-users .user .mood {
		font: 200 14px/20px "Raleway", sans-serif;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	/*****************CHAT BODY *******************/
	.chat-body h6 {
		font-size: 20px;
		margin: 0 0 20px;
	}
	.chat-body .answer.left {
		padding: 0 0 0 58px;
		text-align: left;
		float: left;
	}
	.chat-body .answer {
		position: relative;
		max-width: 600px;
		overflow: hidden;
		clear: both;
	}
	.chat-body .answer.left .avatar {
		left: 0;
	}
	.chat-body .answer .avatar {
		bottom: 36px;
	}
	.chat .avatar {
		width: 40px;
		height: 40px;
		position: absolute;
	}
	.chat .avatar img {
		display: block;
		border-radius: 20px;
		height: 100%;
	}
	.chat-body .answer .name {
		font-size: 14px;
		line-height: 36px;
	}
	.chat-body .answer.left .avatar .status {
		right: 4px;
	}
	.chat-body .answer .avatar .status {
		bottom: 0;
	}
	.chat-body .answer.left .text {
		background: #ebebeb;
		color: #333333;
		border-radius: 8px 8px 8px 0;
	}
	.chat-body .answer .text {
		padding: 12px;
		font-size: 16px;
		line-height: 26px;
		position: relative;
	}
	.chat-body .answer.left .text:before {
		left: -30px;
		border-right-color: #ebebeb;
		border-right-width: 12px;
	}
	.chat-body .answer .text:before {
		content: "";
		display: block;
		position: absolute;
		bottom: 0;
		border: 18px solid transparent;
		border-bottom-width: 0;
	}
	.chat-body .answer.left .time {
		padding-left: 12px;
		color: #333333;
	}
	.chat-body .answer .time {
		font-size: 12px;
		line-height: 25px;
		position: relative;
		padding-bottom: 1px;
	}
	/*RIGHT*/
	.chat-body .answer.right {
		padding: 0 58px 0 0;
		text-align: right;
		float: right;
	}

	.chat-body .answer.right .avatar {
		right: 0;
	}
	.chat-body .answer.right .avatar .status {
		left: 4px;
	}
	.chat-body .answer.right .text {
		background: #7266ba;
		color: #ffffff;
		border-radius: 8px 8px 0 8px;
	}
	.chat-body .answer.right .text:before {
		right: -30px;
		border-left-color: #7266ba;
		border-left-width: 12px;
	}
	.chat-body .answer.right .time {
		padding-right: 12px;
		color: #333333;
	}

	/**************ADD FORM ***************/
	.chat-body .answer-add {
		clear: both;
		position: relative;
		margin: 20px -20px -20px;
		padding: 20px;
		background: #7266ba;
	}

	.answer-add textarea {
		width: 100%;
		background: #7266ba;
		color: white !important;
		border: none;
		outline: none;
		resize: none;
	}
	.answer-add textarea::placeholder {
		color: white !important;
	}

	/* .modal-body */
</style>
